import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

export type NotificationType = 'success' | 'error' | 'warning' | 'info';

const ICONS: Record<NotificationType, string> = {
  success: '✓',
  error: '✕',
  warning: '!',
  info: 'i',
};

const DEFAULT_DURATIONS: Record<NotificationType, number> = {
  success: 3000,
  error: 5000,
  warning: 4500,
  info: 3500,
};

/**
 * Point d'entrée unique pour les messages d'info, de succès, d'erreur et
 * d'avertissement affichés à l'utilisateur. Habille le MatSnackBar avec le
 * design Aethria (voir styles.scss / .aethria-snackbar--*).
 */
@Injectable({ providedIn: 'root' })
export class NotificationService {
  private snackBar = inject(MatSnackBar);

  success(message: string, action = ICONS.success, config?: MatSnackBarConfig): void {
    this.show('success', message, action, config);
  }

  error(message: string, action = ICONS.error, config?: MatSnackBarConfig): void {
    this.show('error', message, action, config);
  }

  warning(message: string, action = ICONS.warning, config?: MatSnackBarConfig): void {
    this.show('warning', message, action, config);
  }

  info(message: string, action = ICONS.info, config?: MatSnackBarConfig): void {
    this.show('info', message, action, config);
  }

  private show(
    type: NotificationType,
    message: string,
    action: string,
    config?: MatSnackBarConfig
  ): void {
    this.snackBar.open(message, action, {
      duration: DEFAULT_DURATIONS[type],
      horizontalPosition: 'end',
      verticalPosition: 'top',
      ...config,
      panelClass: ['aethria-snackbar', `aethria-snackbar--${type}`, ...(config?.panelClass ? (Array.isArray(config.panelClass) ? config.panelClass : [config.panelClass]) : [])],
    });
  }
}
